const NAMED: Record<string, string> = {
  Space: 'Space',
  Escape: 'Esc',
  Enter: 'Enter',
  Tab: 'Tab',
  Backspace: 'Bksp',
  Backquote: '`',
  Minus: '-',
  Equal: '=',
  BracketLeft: '[',
  BracketRight: ']',
  Backslash: '\\',
  Semicolon: ';',
  Quote: "'",
  Comma: ',',
  Period: '.',
  Slash: '/',
  ArrowUp: '↑',
  ArrowDown: '↓',
  ArrowLeft: '←',
  ArrowRight: '→',
  Delete: 'Del',
  Insert: 'Ins',
  Home: 'Home',
  End: 'End',
  PageUp: 'PgUp',
  PageDown: 'PgDn',
};

/** Display label for a key code (`KeyboardEvent.code`, optionally suffixed `+alt`). */
export function keyLabel(code: string): string {
  const alt = code.endsWith('+alt');
  const base = code.replace('+alt', '');
  let s = NAMED[base] ?? base;
  if (base.startsWith('Key')) s = base.slice(3);
  else if (base.startsWith('Digit')) s = base.slice(5);
  else if (base.startsWith('Numpad')) s = `Num ${base.slice(6)}`;
  return alt ? `Alt+${s}` : s;
}
